import { Navigate, useLocation } from "react-router-dom";
import { useAuth, roleHome } from "./AuthContext";

/**
 * ProtectedRoute
 *   - Redirects unauthenticated visitors to /app/login.
 *   - Redirects the wrong role to their own home, appending
 *     `?denied=1&from=<attempted-path>` so AppShell can show a
 *     one-line "you don't have access" banner on arrival.
 */
export default function ProtectedRoute({ children, requireRole }) {
  const { status, user } = useAuth();
  const location = useLocation();

  if (status === "checking") {
    return (
      <div className="min-h-screen bg-[#F6F5F0] flex items-center justify-center">
        <div className="flex items-center gap-3 text-slate-500 text-sm">
          <span className="h-2 w-2 rounded-full bg-[#D4A65A] animate-pulse" />
          Loading your workspace…
        </div>
      </div>
    );
  }

  if (status !== "authed") {
    // Preserve the intended destination so we can bounce back after login.
    const params = new URLSearchParams({ next: location.pathname + location.search });
    return <Navigate to={`/app/login?${params.toString()}`} replace />;
  }

  if (requireRole === "owner" && user?.role !== "owner" && user?.role !== "demo") {
    const params = new URLSearchParams({ denied: "1", from: location.pathname });
    return <Navigate to={`${roleHome(user)}?${params.toString()}`} replace />;
  }

  return children;
}
